import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Tequila from "./pages/Tequila";
import Diffusion from "./pages/Diffusion";
import Sammy from "./pages/Sammy";
import Cv from "./pages/Cv";
import Flow from "./pages/Flow";
import Blog from "./pages/Blog";
import NotFound from "./pages/NotFound";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tequila" element={<Tequila />} />
        <Route path="/diffusion" element={<Diffusion />} />
        <Route path="/sammy" element={<Sammy />} />
        <Route path="/cv" element={<Cv />} />
        <Route path="/flow" element={<Flow />} />
        <Route path="/blog/:slug" element={<Blog />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
